/**
 * Returns panorama window object
 * @returns { Panorama }
 */
const getPanorama = () => {
    var _a;
    let panoramaWindow;
    try {
        panoramaWindow = window.panorama || ((_a = window.top) === null || _a === void 0 ? void 0 : _a.panorama);
    }
    catch (e) {
        // no-op
    }
    return panoramaWindow;
};
/**
 * Check if Panorama method available in top window for same origin iFrames
 * @returns { boolean }
 */
const isPanoramaAvailableInTopWindow = () => {
    let isPanoramaAvailable = false;
    try {
        isPanoramaAvailable = window.top && window.top.panorama && typeof window.top.panorama === "function";
    }
    catch (e) {
        // no-op
    }
    return isPanoramaAvailable;
};
/**
 * Checks if Panorama is enabled in current page
 * @returns { boolean }
 */
export const isPanoramaEnabled = () => {
    let isPanoramaEnabled = false;
    try {
        isPanoramaEnabled = (window.panorama && typeof window.panorama === "function") || isPanoramaAvailableInTopWindow();
    }
    catch (e) {
        // no-op
    }
    return isPanoramaEnabled;
};
/**
 * Checks if Panorama is enabled and empties existing metric buffer
 */
const checkIfCanEmptyBuffer = () => {
    if (isPanoramaEnabled()) {
        initialBuffer.forEach(metric => {
            emitPanoramaCustomEvent(metric);
        });
    }
};
// Maintain metrics until Panorama is enabled on the page
const initialBuffer = [];
/**
 * Push the metrics to internal buffer until Panorama is enabled
 * @param { Metric } metric
 */
const pushToBuffer = (metric) => {
    initialBuffer.push(metric);
    checkIfCanEmptyBuffer();
};
/**
 * Emits Panorama custom event
 * @param { Metric } metric
 */
export const emitPanoramaCustomEvent = (metric) => {
    if (!isPanoramaEnabled()) {
        pushToBuffer(Object.assign(Object.assign({}, metric), { timestamp: Date.now() }));
        return;
    }
    const panoramaWindow = getPanorama();
    if (panoramaWindow && typeof panoramaWindow === "function") {
        panoramaWindow("trackCustomEvent", Object.assign(Object.assign({}, metric), { timestamp: metric.timestamp || Date.now() }));
    }
};
export const emitFunnelInteractionEvent = (metric) => {
    return emitPanoramaCustomEvent(Object.assign(Object.assign({}, metric), { eventType: "funnelInteraction" }));
};
export const emitPerformanceMetric = (metric) => {
    return emitPanoramaCustomEvent(Object.assign(Object.assign({}, metric), { eventType: "performance", eventSource: "polaroid" }));
};
export const withErrorHandling = (fnName) => (func) => {
    return (...args) => {
        try {
            return func(...args);
        }
        catch (err) {
            try {
                emitPanoramaCustomEvent({
                    eventContext: fnName,
                    eventSource: "panoramaInternal",
                    eventDetail: err ? err.toString() : "",
                });
            }
            catch (_a) {
                // Do nothing
            }
        }
    };
};
